module.exports = __webpack_public_path__ + "static/media/icon_atualizar_carrinho.e522beb3.svg";